<template>
  <DxDropDownBox
    :ref="`dropDownBoxRef${cellInfo.key}`"
    :value="cellInfo.value"
    :drop-down-options="{ width: options.dropBoxWidth }"
    :defer-rendering="false"
    :data-source="dataSource"
    :display-expr="options.displayExpr"
    :value-expr="options.valueExpr"
  >
    <div style="margin: 10px !important;">
      <DxDataGrid
        :data-source="dataSource"
        :hover-state-enabled="true"
        :focused-row-enabled="true"
        :width="options.gridWidth"
        height="300px"
        :word-wrap-enabled="true"
        :show-row-lines="true"
        :editing="{ allowUpdating: false }"
        :selection="{ mode: options.selectionMode, deferred: false }"
        :filter-row="{ visible: true }"
        :on-content-ready="() => {}"
        :key-expr="options.keyExpr"
        @selection-changed="e => onSelectionChanged(e, cellInfo)"
        :on-initialized="() => null"
      >
        <DxPaging :enabled="options.paging" :page-size="options.pagingSize" />
        <DxColumn
          v-for="(item, idx) in options.columns"
          :key="item.fieldCd+idx"
          :data-field="item.fieldCd"
          :caption="item.fieldNm"
          :width="item.width"
        />
      </DxDataGrid>
    </div>
  </DxDropDownBox>
</template>

<script>
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
export default {
  mixins: [BaseDataGrid], //20220414 LYJ base page 추가
  name: 'CustomDropBoxGridTemplate',
  components: { DxDropDownBox },
  props: {
    cellInfo: {
      type: Object,
      default: () => {}
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {
        return {
          dropBoxWidth: '100%',
          gridWidth: '100%',
          displayExpr: 'cd',
          valueExpr: 'cd',
          keyExpr: 'cd',
          selectionMode: 'single',
          columns: [
            {
              fieldCd: 'cd',
              fieldNm: 'CODE',
              width: '200px'
            },
            {
              fieldCd: 'nm',
              fieldNm: 'NAME',
              width: '250px'
            }
          ],
          paging: true,
          pagingSize: 5
        }
      }
    }
  },
  data() {
    return {}
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    onSelectionChanged(e, cellInfo) {
      if (e.selectedRowsData.length === 0) return
      this.$refs[`dropDownBoxRef${cellInfo.key}`].instance.option('value', e.selectedRowKeys)
      this.$emit('onSelectionChanged', e, cellInfo)
    }
  }
}
</script>